import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { RouterFetchSiteConfig } from '../types'

const routerFetchSiteConfig: SiteConfigFn<RouterFetchSiteConfig> = ({ api }) => {
	const isDynamicPagesActive = api.features.isActive('dynamicPages')
	const isLightboxesActive = api.features.isActive('lightbox')
	const shouldLoad = isDynamicPagesActive || isLightboxesActive

	const externalBaseUrl = api.publicModel.getExternalBaseUrl()
	const viewMode = api.env.getViewMode()

	return {
		shouldLoadSiteFeature: shouldLoad,
		shouldLoadSiteConfig: shouldLoad,
		siteConfig: {
			externalBaseUrl,
			viewMode,
		},
	}
}

const name = 'routerFetch'

export const config = { site: routerFetchSiteConfig, name }
